<script setup>
import {SiteFooter, useServiceCatalogStore} from '@ismet/vue-ui-kit'

const emit = defineEmits(['openChatWidget']);

const serviceCatalog = useServiceCatalogStore();
</script>

<template>
  <SiteFooter dark :section="'Kazakhtelecom_Business_MAIN'" :typePage="'HOME'" @openHelpdesk="emit('openChatWidget')" />
  <div class="sticky-block">
    <button class="footer__catalog" @click="serviceCatalog.triggerOpen()">
      {{$t('Каталог услуг')}}
    </button>
  </div>

</template>
<style scoped lang="scss">
.footer {
  width: 100%;
  padding: 48px 0 24px;
  color: #fff;

  background: linear-gradient(
      135deg,
      #101828 0%,
      #1e2939 50%,
      #101828 100%
  );

  &__inner {
    max-width: 1280px;
    margin: 0 auto;
  }

  &__top {
    display: grid;
    grid-template-columns: 200px 1fr 260px;
    gap: 40px;
  }

  &__logo img {
    width: 160px;
  }

  &__columns {
    display: flex;
    gap: 53px;
  }

  &__col {
    min-width: 227px;
    h4 {
      margin-bottom: 17px;
      font-size: 18px;
      font-weight: 500;
      line-height: 28px;
    }

    ul {
      list-style: none;
      padding: 0;
      margin: 0;
    }

    li {
      margin-bottom: 17px;
      a,div {
        color: #8D959D;
        cursor: pointer;
        transition: color 0.2s;
        font-size: 16px;
        white-space: pre-line;
        text-decoration: none;
        &:hover {
          color: #F0F1F5;
        }
      }
      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  &__actions {
    display: flex;
    flex-direction: column;
    gap: 16px;
    max-width: 209px;
  }

  &__btn {
    height: 40px;
    border-radius: 8px;
    border: none;
    background: rgba(66, 79, 98, 0.33);
    color: #8D959D;
    cursor: pointer;
    font-size: 14px;
    text-decoration: none;

    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    transition: background 0.2s ease;
    span {
      font-size: 16px;
      color: $color-primary;
    }
    &.primary {
      color: $color-primary;
      background: $primary-blue;
      &:hover {
        background: #0076DA;
      }
    }
    &:hover {
        background: rgba(66, 79, 98, 0.87);
    }
    &.mobile {
      display: none;
    }
  }

  &__store {
    height: 40px;
    border-radius: 10px;
    border: none;
    background: rgba(66, 79, 98, 0.33);
    color: #fff;
    cursor: pointer;
    transition: background 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    &:hover {
      background: rgba(66, 79, 98, 0.87);
    }
    &.mobile {
      display: none;
    }
  }

  &__socials {
    display: flex;
    gap: 10px;
    margin-top: 10px;
    justify-content: center;
    a {
      width: 30px;
      height: 30px;
      padding: 6px;
      border-radius: 6px;
      background: transparent;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      transition: background 0.2s ease;
      &:hover {
        background: #283243;
      }
    }
  }

  &__divider {
    margin: 24px 0;
    height: 1px;
    background: #364153;
  }

  &__bottom {
    display: flex;
    justify-content: space-between;
    font-size: 16px;
    color: #8D959D;
  }

  &__links {
    display: flex;
    gap: 24px;

    a {
      color: #8D959D;
      text-decoration: none;
      transition: color 0.2s ease;
      &:hover {
        color: #F0F1F5;
      }
    }
  }
}
.sticky-block {
  display: none;
}
@media (max-width: 1440px) {
  .footer {
    padding: 48px 80px 24px;
  }
}
@media (max-width: 1280px) {
  .footer {
    &__top {
      gap: 24px;
      grid-template-columns: 175px 1fr 260px;
    }
    &__col {
      min-width: 213px;
    }
    &__columns {
      gap: 24px;
    }
  }
}
@media (max-width: 1024px) {
  .footer {
    padding: 48px 64px 24px;
    &__top {
      gap: 24px;
      grid-template-columns: 147px 1fr 260px;
    }
    &__col {
      min-width: 171px;
      h4 {
        font-size: 16px;
      }
      li a {
        font-size: 14px;
      }
    }
    &__socials a {
      width: 24px;
      height: 24px;
      img {
        width: 24px;
        height: 24px;
      }
    }
    &__btn {
      font-size: 12px;
    }
    &__actions {
      max-width: 178px;
    }
    &__columns {
      gap: 0;
    }
  }
}
@media (max-width: 860px) {
  .footer {
    padding: 42px 16px 26px;
    background: #fff;

    &__inner {
      max-width: none;
    }

    &__top {
      display: block;
    }

    &__logo,
    &__columns,
    &__divider,
    &__socials,
    &__bottom {
      display: none;
    }

    &__actions {
      max-width: none;
      gap: 18px;
    }

    &__btn,
    &__store,
    &__catalog {
      width: 100%;
      min-height: 40px;
      border-radius: 14px;
      box-sizing: border-box;

      font-size: 14px;
      font-weight: 400;
    }

    &__btn {
      display: none;
      &.mobile {
        display: flex;
        background: #fff;
        border: 1px solid #d4dae1;
        color: #333;
      }


      img {
        width: 22px;
        height: 22px;
      }

      span {
        font-size: 18px;
        color: #333;
      }

      &.primary {
        border: 0;
        background: #1388ee;
        color: #fff;

        img {
          filter: brightness(0) invert(1);
        }
      }
    }

    &__store {
      display: none;
      &.mobile {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 10px;
        background: #fff;
        border: 1px solid #d4dae1;
      }
      img {
        max-width: 132px;
        max-height: 24px;
      }
    }


  }
  .sticky-block {
    display: block;
    width: 100%;
    position: sticky;
    bottom: 0;
    padding: 16px;
    background: rgba(255, 255, 255, 0.72);
    .footer__catalog {
      width: 100%;
      border: 0;
      background: #1388ee;
      color: #fff;
      cursor: pointer;
      border-radius: 8px;
      font-size: 16px;
      line-height: 24px;
      font-weight: 500;
      height: 40px;
      min-height: 40px;
    }
  }
}

</style>
